
import { defineComponent } from 'vue'
import KnHint from '@/components/UI/KnHint.vue'

export default defineComponent({
    name: 'kpi-scheduler-hint',
    components: { KnHint }
})
